import React from "react";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import classNames from "classnames/bind";

import { Product } from "@core/types";
import ImageWithBadgeAndWishlist from "./ImageWithBadgeAndWishlist";
import PriceAndCart from "./PriceAndCart";
import Description from "./Description";
import DetailsRow from "./DetailsRow";

import styles from "./NewListViewProduct.module.scss";
import "./NewListViewProduct.module.scss";

import { useProductCardActions } from "../../../../../providers/useProductActions";

interface ProductCartProps {
  product: Product;
  lazyload?: boolean;
  type: "list-for-wish" | "newList";
  className?: string;
}

const cx = classNames.bind(styles);

const NewListViewProduct = ({ type, product, lazyload, className }: ProductCartProps) => {
  const { showProductDetail } = useProductCardActions();

  return (
    <div className={cx("skeletonWidth", "product-component", "productsSpecial", "bottomMargin", "product", className)}>
      <IonGrid className={cx("new-list-view")} onClick={() => showProductDetail(product.id)}>
        <IonRow className={cx("productsSpecial__wrapper")}>
          <ImageWithBadgeAndWishlist product={product} lazyLoad={lazyload} type={type} />
          <IonCol sizeXs="8" sizeSm={"12"} className={cx("productsSpecial__descriptionWrapper")}>
            <IonRow className={cx("descriptionWrapper", "descriptionWrapper__row")}>
              <Description product={product} type={type} />
              <PriceAndCart product={product} />
            </IonRow>
            <DetailsRow product={product} type={type} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

NewListViewProduct.displayName = "CORE_NewListViewProduct";

export default NewListViewProduct;
